/**
 * Mirrors server `SnapshotRestartValidation.DefaultStaleThreshold` (POST restart-snapshot).
 * Keep in sync when changing the API policy.
 */
export const SNAPSHOT_RESTART_STALE_MS = 10 * 60_000;

/**
 * True when the data package row has had no updates for at least {@link SNAPSHOT_RESTART_STALE_MS},
 * so POST .../restart-snapshot is expected to succeed. Missing date is treated as eligible.
 */
export function isSnapshotBuildStaleForRestart(
  lastChangedDate: Date | string | undefined | null,
  nowMs = Date.now()
): boolean {
  if (lastChangedDate == null) {
    return true;
  }
  const t = lastChangedDate instanceof Date ? lastChangedDate.getTime() : new Date(lastChangedDate).getTime();
  if (Number.isNaN(t)) {
    return true;
  }
  return nowMs - t >= SNAPSHOT_RESTART_STALE_MS;
}
